import React from 'react';
import { Link } from 'react-router-dom';
import { Home } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const NotFoundPage = () => {
  const { t } = useLanguage();

  return (
    <main
      className="flex-1 min-h-screen bg-[#0a0a0a] flex flex-col items-center justify-center px-4 py-16 text-center"
      data-testid="not-found-page"
    >
      <p className="text-6xl md:text-8xl font-bold text-[#7AC142] font-mono">404</p>
      <h1 className="mt-6 text-3xl md:text-4xl font-extrabold text-white tracking-tight">
        {t('notFound.title')}
      </h1>
      <p className="mt-4 text-gray-400 max-w-md">{t('notFound.description')}</p>
      <Link
        to="/"
        className="mt-10 inline-flex items-center gap-2 bg-[#7AC142] text-black px-8 py-4 font-bold uppercase tracking-wider hover:bg-[#69A835] transition-colors"
        data-testid="not-found-home"
      >
        <Home className="w-5 h-5" />
        {t('notFound.cta')}
      </Link>
    </main>
  );
};

export default NotFoundPage;
